import styled, { css } from 'styled-components'

type NormalImageProps = {
  objectFit?: React.CSSProperties['objectFit']
  objectPosition?: React.CSSProperties['objectPosition']
  full?: boolean
}

type NormalImageWrapperProps = {
  width?: React.CSSProperties['width']
  height?: React.CSSProperties['height']
  full?: boolean
}

export const ImageInner = styled.img<NormalImageProps>`
  max-width: 100%;
  width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  max-height: ${(props) => (props.height ? `${props.height}px` : '100%')};
  object-fit: ${(props) => props.objectFit};
  object-position: ${(props) => props.objectPosition};

  ${({ full }) =>
    full &&
    css`
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
    `}
`

export const ImageWrapper = styled.div<NormalImageWrapperProps>`
  display: flex;
  max-width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  max-height: ${(props) => (props.height ? `${props.height}px` : '100%')};

  ${({ full }) =>
    full &&
    css`
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
    `}
`
